import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Chip,
    Stack,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    IconButton,
    Tabs,
    Tab
} from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import DirectionsBikeIcon from '@mui/icons-material/Moped';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CloseIcon from '@mui/icons-material/Close';

export default function CourierCargo() {
    const [courierModalOpen, setCourierModalOpen] = useState(false);
    const [cargoModalOpen, setCargoModalOpen] = useState(false);
    const [cancelModalOpen, setCancelModalOpen] = useState(false);
    const [deliveryModalOpen, setDeliveryModalOpen] = useState(false);
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [activeTab, setActiveTab] = useState('active');
    const [step, setStep] = useState(0);
    const [selectedCompany, setSelectedCompany] = useState('');
    const [requestType, setRequestType] = useState('');
    const [requests, setRequests] = useState({
        kargo: [
            { id: '123456712', date: '15.05.2025 - 13:44', status: 'Tamamlandı', payment: 'Ödendi' },
            { id: '123456713', date: '15.05.2025 - 13:44', status: 'İptal', payment: 'Ödeme Bekleniyor' },
            { id: '123456714', date: '15.05.2025 - 13:44', status: 'Ödeme Bekleniyor', payment: 'Ödeme Bekleniyor' },
            { id: '123456715', date: '15.05.2025 - 13:44', status: 'Ödendi', payment: 'Ödendi' }
        ],
        kurye: [
            { id: '987654321', date: '16.05.2025 - 10:30', status: 'Ödeme Bekleniyor', payment: 'Ödeme Bekleniyor' },
            { id: '987654322', date: '16.05.2025 - 11:15', status: 'Ödendi', payment: 'Ödendi' },
            { id: '987654323', date: '16.05.2025 - 12:30', status: 'Ödendi', payment: 'Ödendi' }
        ]
    });

    const companies = {
        kurye: ['Vigo'],
        kargo: ['Kargoist']
    };

    const handleCancel = (request) => {
        setSelectedRequest(request);
        setCancelModalOpen(true);
    };

    const handleDelivery = (request) => {
        setSelectedRequest(request);
        setDeliveryModalOpen(true);
    };

    const confirmCancel = () => {
        if (selectedRequest && requestType) {
            const updatedRequests = requests[requestType].map(req =>
                req.id === selectedRequest.id ? { ...req, status: 'İptal' } : req
            );
            setRequests({
                ...requests,
                [requestType]: updatedRequests
            });
            setCancelModalOpen(false);
        }
    };

    const confirmDelivery = () => {
        if (selectedRequest && requestType) {
            const updatedRequests = requests[requestType].map(req =>
                req.id === selectedRequest.id ? { ...req, status: 'Tamamlandı' } : req
            );
            setRequests({
                ...requests,
                [requestType]: updatedRequests
            });
            setDeliveryModalOpen(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'İptal': return '#DA3831';
            case 'Tamamlandı': return '#4CAF50';
            case 'Ödeme Bekleniyor': return '#FFA000';
            case 'Ödendi': return '#2196F3';
            default: return 'inherit';
        }
    };

    const shouldShowDeliveryButton = (request) => {
        return request.payment === 'Ödendi' &&
            request.status !== 'Tamamlandı' &&
            request.status !== 'İptal';
    };

    const filterActiveRequests = (reqList) => {
        return reqList.filter(req =>
            req.status !== 'Tamamlandı' && req.status !== 'İptal'
        );
    };

    const filterCompletedRequests = (reqList) => {
        return reqList.filter(req =>
            req.status === 'Tamamlandı' || req.status === 'İptal'
        );
    };
    return (
        <Box p={4} bgcolor="#f9f9f9" minHeight="100vh">
            {/* Header */}
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={4}
                pb={1}
                borderBottom="1px solid #EBEBEB"
            >
                <Box display="flex" alignItems="center" gap={2}>
                    <Box>
                        <Typography variant="h6" fontWeight={600}>
                            Kurye - Kargo
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {step === 0
                                ? 'Kurye - Kargo işlemleri'
                                : requestType === 'kurye'
                                    ? 'Kurye Talebi Oluştur'
                                    : 'Kargo Talebi Oluştur'}
                        </Typography>
                    </Box>
                </Box>
                {step === 0 && (
                    <Chip
                        label="Bekleyen Talepler: 4"
                        color="error"
                        variant="outlined"
                        sx={{ fontWeight: 500, color: 'rgba(218, 56, 49, 1)', borderColor: 'rgba(255, 219, 217, 1)' }}
                    />
                )}
                {step !== 0 && (
                    <Box sx={{ p: 1, alignItems: 'center', justifyContent: 'center', backgroundColor: 'white', boxShadow: 1, borderRadius: 1 }}>
                        <IconButton
                            sx={{ width: '20px', height: '20px' }}
                            onClick={() => {
                                setStep(0);
                                setSelectedCompany('');
                                setRequestType('');
                            }}
                            color="inherit"
                        >
                            <ArrowBackIcon />
                        </IconButton>
                    </Box>
                )}
            </Box>

            {/* Step 0 */}
            {step === 0 && (
                <>
                    <Stack spacing={2} mb={6}>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<DirectionsBikeIcon />}
                            sx={{ py: 2, fontWeight: 500, justifyContent: 'flex-start', backgroundColor: '#DA3831' }}
                            onClick={() => {
                                setRequestType('kurye');
                                setStep(1);
                            }}
                        >
                            Kurye Talebi Oluşturma QR Kodu
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<LocalShippingIcon />}
                            sx={{ py: 2, fontWeight: 500, justifyContent: 'flex-start', backgroundColor: '#DA3831' }}
                            onClick={() => {
                                setRequestType('kargo');
                                setStep(1);
                            }}
                        >
                            Kargo Talebi Oluşturma QR Kodu
                        </Button>
                    </Stack>

                    <Typography variant="body2" color="text.secondary" mb={2}>
                        Kurye - Kargo Talepleri
                    </Typography>

                    <Stack spacing={2}>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<DirectionsBikeIcon />}
                            sx={{ py: 2, fontWeight: 500, backgroundColor: '#DA3831', justifyContent: 'flex-start' }}
                            onClick={() => {
                                setCourierModalOpen(true)
                                setRequestType('kurye');
                            }}
                        >
                            Kurye Gönderi Talepleri
                        </Button>
                        <Button
                            variant="contained"
                            fullWidth
                            color="error"
                            startIcon={<LocalShippingIcon />}
                            sx={{ py: 2, fontWeight: 500, backgroundColor: '#DA3831', justifyContent: 'flex-start' }}
                            onClick={() => {
                                setCargoModalOpen(true)
                                setRequestType('kargo');
                            }}
                        >
                            Kargo Gönderi Talepleri
                        </Button>
                    </Stack>
                </>
            )}

            {/* Step 1 – Firma Seçimi */}
            {step === 1 && (
                <Stack spacing={3} maxWidth={740}>
                    <FormControl fullWidth>
                        <InputLabel>Firma Seç</InputLabel>
                        <Select
                            value={selectedCompany}
                            label="Anlaşmalı Firma Seçiniz"
                            onChange={(e) => setSelectedCompany(e.target.value)}
                        >
                            {companies[requestType].map((company) => (
                                <MenuItem key={company} value={company}>
                                    {company}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    {selectedCompany && (
                        <Box
                            width={300}
                            height={300}
                            bgcolor="#e0e0e0"
                            display="flex"
                            alignItems="center"
                            justifyContent="center"
                            borderRadius={2}
                            flexDirection="column"
                            gap={2}
                        >
                        </Box>
                    )}
                </Stack>
            )}

            {/* Kargo Modalı */}
            <Dialog
                open={cargoModalOpen}
                onClose={() => setCargoModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%'
                    }
                }}
            >
                <DialogTitle sx={{ p: 2 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Typography variant="h6" textAlign='center'>Kargo Talepleri</Typography>
                        <IconButton
                            onClick={() => setCargoModalOpen(false)}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 2 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        TabIndicatorProps={{ style: { display: 'none' } }} // alt çizgiyi gizle
                        sx={{
                            mb: 2,
                            justifyContent: 'center',
                            '& .MuiTabs-flexContainer': {
                                backgroundColor: 'rgba(255, 239, 239, 1)',
                                borderRadius: '8px 8px',
                                p: .5,
                                gap: .5,
                                maxWidth: '340px',
                                mx: 'auto',
                                justifyContent: 'center'
                            },
                        }}
                    >
                        <Tab
                            label="Aktif Talepler"
                            value="active"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'active' ? '#fff' : 'transparent',
                                color: activeTab === 'active' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'active' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                        <Tab
                            label="Tamamlanan Talepler"
                            value="completed"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'completed' ? '#fff' : 'transparent',
                                color: activeTab === 'completed' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'completed' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                    </Tabs>
                    <Stack spacing={2}>
                        {(activeTab === 'active'
                            ? filterActiveRequests(requests.kargo)
                            : filterCompletedRequests(requests.kargo)).map((request) => (
                                <Box key={request.id} p={2} border="1px solid #EBEBEB" borderRadius={2} position='relative'>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={600}>Kargoist Gönderim Talebi</Typography>
                                        <Box>
                                            {shouldShowDeliveryButton(request) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    sx={{ backgroundColor: '#DA3831', width: '100%', maxWidth: '100px', padding: '10px 20px', position: 'absolute', bottom: '8px', right: '14px' }}
                                                    onClick={() => handleDelivery(request)}
                                                >
                                                    Teslim Al
                                                </Button>
                                            )}
                                            {request.status !== 'Tamamlandı' && request.status !== 'İptal' && (
                                                <Box sx={{ position: 'absolute' }} backgroundColor="rgba(237, 236, 236, 1)" borderRadius='50%' right="14px" top="14px" display="flex">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleCancel(request)}
                                                        disabled={request.status === 'İptal' || request.status === 'Tamamlandı'}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </Box>

                                    </Box>

                                    <Typography variant="body2">Gönderi Kodu: {request.id}</Typography>
                                    <Typography variant="body2">Tarih: {request.date}</Typography>
                                    <Typography variant="body2">
                                        Durum: <span style={{ color: getStatusColor(request.status) }}>{request.status}</span>
                                    </Typography>
                                </Box>
                            ))}
                    </Stack>
                </DialogContent>
            </Dialog>

            {/* Kurye Modalı */}
            <Dialog
                open={courierModalOpen}
                onClose={() => setCourierModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        pt: 4,
                        pb: 8,
                    },
                }}
            >
                <DialogTitle sx={{ p: 2 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                        <Typography variant="h6">Kurye Talepleri</Typography>
                        <IconButton
                            onClick={() => setCourierModalOpen(false)}
                            sx={{ position: 'absolute', right: 8, top: 8 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </DialogTitle>
                <DialogContent sx={{ p: 2 }}>
                    <Tabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        TabIndicatorProps={{ style: { display: 'none' } }} // alt çizgiyi gizle
                        sx={{
                            mb: 2,
                            justifyContent: 'center',
                            '& .MuiTabs-flexContainer': {
                                backgroundColor: 'rgba(255, 239, 239, 1)',
                                borderRadius: '8px 8px',
                                p: .5,
                                gap: .5,
                                maxWidth: '340px',
                                mx: 'auto',
                                justifyContent: 'center'
                            },
                        }}
                    >
                        <Tab
                            label="Aktif Talepler"
                            value="active"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'active' ? '#fff' : 'transparent',
                                color: activeTab === 'active' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'active' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                        <Tab
                            label="Tamamlanan Talepler"
                            value="completed"
                            sx={{
                                flex: 1,
                                textTransform: 'none',
                                fontWeight: 600,
                                fontSize: 13,
                                borderRadius: '8px 8px',
                                backgroundColor: activeTab === 'completed' ? '#fff' : 'transparent',
                                color: activeTab === 'completed' ? 'rgba(52, 64, 84, 1)' : 'rgba(133, 108, 102, 1)',
                                boxShadow: activeTab === 'completed' ? '0 -2px 4px rgba(0,0,0,0.1)' : 'none',
                                px: 2,
                                py: 1.5,
                                minWidth: 'auto',
                            }}
                        />
                    </Tabs>
                    <Stack spacing={2} position="relative">
                        {(activeTab === 'active'
                            ? filterActiveRequests(requests.kurye)
                            : filterCompletedRequests(requests.kurye)).map((request) => (
                                <Box key={request.id} p={2} border="1px solid #EBEBEB" borderRadius={2} position='relative'>
                                    <Box display="flex" justifyContent="space-between" alignItems="center">
                                        <Typography fontWeight={600}>Kargoist Gönderim Talebi</Typography>
                                        <Box>
                                            {shouldShowDeliveryButton(request) && (
                                                <Button
                                                    variant="contained"
                                                    color="error"
                                                    size="small"
                                                    sx={{ backgroundColor: '#DA3831', width: '100%', maxWidth: '100px', padding: '10px 20px', position: 'absolute', bottom: '8px', right: '14px' }}
                                                    onClick={() => handleDelivery(request)}
                                                >
                                                    Teslim Al
                                                </Button>
                                            )}
                                            {request.status !== 'Tamamlandı' && (
                                                <Box sx={{ position: 'absolute' }} backgroundColor="rgba(237, 236, 236, 1)" borderRadius='50%' right="14px" top="14px" display="flex">
                                                    <IconButton
                                                        size="small"
                                                        onClick={() => handleCancel(request)}
                                                        disabled={request.status === 'İptal' || request.status === 'Tamamlandı'}
                                                    >
                                                        <CloseIcon fontSize="small" />
                                                    </IconButton>
                                                </Box>
                                            )}
                                        </Box>

                                    </Box>
                                    <Typography variant="body2">Gönderi Kodu: {request.id}</Typography>
                                    <Typography variant="body2">Tarih: {request.date}</Typography>
                                    <Typography variant="body2">
                                        Durum: <span style={{ color: getStatusColor(request.status) }}>{request.status}</span>
                                    </Typography>
                                </Box>
                            ))}
                    </Stack>
                </DialogContent>
            </Dialog>

            {/* Teslim Al Modalı */}
            <Dialog open={deliveryModalOpen} onClose={() => setDeliveryModalOpen(false)}
                maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        py : 2.5,
                    },
                }}
            >
                <DialogTitle>
                    <Box sx={{
                        backgroundColor: 'rgba(250, 232, 220, 1)',
                        border: '8px solid rgba(253, 244, 236, 1)',
                        width: 'fit-content',
                        padding: 1.5,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {requestType === 'kargo' ?
                            <LocalShippingIcon sx={{ color: '#DA3831', width: 22 }} /> :
                            <DirectionsBikeIcon sx={{ color: '#DA3831', width: 22 }} />
                        }
                    </Box>
                    <Typography variant='h4' sx={{ fontSize: '18px' }}>{requestType === 'kargo' ? 'Kargoist Gönderi Teslim Alma Onayı' : 'Vigo Gönderi Teslim Alma Onayı'}</Typography>
                </DialogTitle>
                <DialogContent>
                     <Typography sx={{
                        fontSize: '14px',
                        color: 'rgba(71, 84, 103, 1)'
                    }}>
                        "{selectedRequest?.id}" Nolu müşteri gönderisini teslim alma işlemini <strong>onaylıyor musunuz?</strong>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    px : 2,
                }}>
                    <Button sx={{
                        backgroundColor: '#DA3831',
                        color: 'white',
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        py: 1.5,
                        marginLeft: '0 !important'
                    }} onClick={confirmDelivery} color="error" variant="contained">
                        Onayla
                    </Button>
                    <Button sx={{
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        color: 'rgba(52, 64, 84, 1)',
                        border: '1px solid rgba(208, 213, 221, 1)',
                        marginLeft: '0 !important',
                        py: 1.5
                    }} onClick={() => setDeliveryModalOpen(false)} color="inherit">
                        Vazgeç
                    </Button>
                </DialogActions>
            </Dialog>

            {/* İptal Modalı */}
            <Dialog open={cancelModalOpen} onClose={() => setCancelModalOpen(false)} maxWidth="sm"
                fullWidth
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: '460px',
                        width: '100%',
                        py : 2.5,
                    '& .MuiDialog-paper .MuiTypography-root': {
                        paddingInline : '0 !important',
                    }
                    },
                }}>
                <DialogTitle>
                    <Box sx={{
                        backgroundColor: 'rgba(250, 232, 220, 1)',
                        border: '8px solid rgba(253, 244, 236, 1)',
                        width: 'fit-content',
                        padding: 1.5,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}>
                        {requestType === 'kargo' ?
                            <LocalShippingIcon sx={{ color: '#DA3831', width: 22 }} /> :
                            <DirectionsBikeIcon sx={{ color: '#DA3831', width: 22 }} />
                        }
                    </Box>
                    <Typography variant='h4' sx={{
                        fontSize: '18px',
                    }}>{requestType === 'kargo' ? 'Kargoist İşlem İptal Onayı' : 'Vigo İşlem İptal Onayı'}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography sx={{
                        fontSize: '14px',
                        color: 'rgba(71, 84, 103, 1)'
                    }}>
                        "{selectedRequest?.id}" Nolu müşteri gönderisi için {requestType === 'kargo' ? 'kargo' : 'kurye'} çağırma işleminin iptalini <strong>onaylıyor musunuz?</strong>
                    </Typography>
                </DialogContent>
                <DialogActions sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 1,
                    px: 2,
                }}>
                    <Button sx={{
                        backgroundColor: '#DA3831',
                        color: 'white',
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        py: 1.5,
                        marginLeft: '0 !important'
                    }} onClick={confirmCancel} color="error" variant="contained">
                        Onayla
                    </Button>
                    <Button sx={{
                        width: '100%',
                        fontSize: '16px',
                        textAlign: 'center',
                        color: 'rgba(52, 64, 84, 1)',
                        border: '1px solid rgba(208, 213, 221, 1)',
                        py: 1.5,
                        marginLeft: '0 !important',
                    }} onClick={() => setCancelModalOpen(false)} color="inherit">
                        Vazgeç
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
